import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { LanguageType } from 'app/shared/model/enumerations/language-type.model';
import { createEntity, getEntity, reset, updateEntity } from './error-message.reducer';

export const ErrorMessageUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const errorMessageEntity = useAppSelector(state => state.errorMessage.entity);
  const loading = useAppSelector(state => state.errorMessage.loading);
  const updating = useAppSelector(state => state.errorMessage.updating);
  const updateSuccess = useAppSelector(state => state.errorMessage.updateSuccess);
  const languageTypeValues = Object.keys(LanguageType);

  const handleClose = () => {
    navigate('/error-message');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...errorMessageEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          language: 'NL',
          ...errorMessageEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.errorMessage.home.createOrEditLabel" data-cy="ErrorMessageCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.errorMessage.home.createOrEditLabel">
              Create or edit a ErrorMessage
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="error-message-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.errorMessage.language')}
                id="error-message-language"
                name="language"
                data-cy="language"
                type="select"
              >
                {languageTypeValues.map(languageType => (
                  <option value={languageType} key={languageType}>
                    {translate(`crawlerBackendApp.LanguageType.${languageType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.errorMessage.errorCode')}
                id="error-message-errorCode"
                name="errorCode"
                data-cy="errorCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('crawlerBackendApp.errorMessage.message')}
                id="error-message-message"
                name="message"
                data-cy="message"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('crawlerBackendApp.errorMessage.errorName')}
                id="error-message-errorName"
                name="errorName"
                data-cy="errorName"
                type="text"
              />
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/error-message"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ErrorMessageUpdate;
